import HttpUtils from "../utils/HttpUtils";

// /**
//  * 记录访问量（对接后端 /web/access/record）
//  * @param {string} projectCode 项目编码
//  * @param {string} projectName 项目名称
//  * @param {string} accessPath 访问路径
//  * @param {boolean} isDownload 1 = 下载资源，0 = 访问页面
//  * @param {number} resourceType 资源类型：1=教师资源, 2=学生资源, 0 非下载资源
//  */
// const  recordAccess = ( accessPath: string,isDownload: 0|1 = 0, resourceType:1|2|0=0, resourceName: string) => {
//   // 默认值
//   const DEFAULT_PROJECT_CODE = 'qzkt_web'       // 默认项目编码
//   const DEFAULT_PROJECT_NAME = 'study.ooowin.com'         // 默认项目名称
//   return HttpUtils.post("/web/access-statistics/record", {
//     projectCode: DEFAULT_PROJECT_CODE,
//     projectName: DEFAULT_PROJECT_NAME,
//     accessPath: accessPath || window.location.pathname,
//     isDownload: isDownload,
//     resourceType: resourceType,
//     resourceName: resourceName
//   })
// }

interface AccessParams {
  accessPath: string
  isDownload?: 0 | 1
  resourceType?: 1 | 2 | 6| 7 | 0
  resourceName?: string
}

const recordAccess = ({
  accessPath,
  isDownload = 0,
  resourceType = 0,
  resourceName = ''
}: AccessParams) => {
  return HttpUtils.post("/web/access-statistics/record", {
    projectCode: 'qzkt_web',
    projectName: 'study.ooowin.com',
    accessPath: accessPath || window.location.pathname,
    isDownload,
    resourceType,
    resourceName
  })
}


// 获取当前用户IP地址（对接后端 /web/ipUtils/getIpAddr)
const getRealIpAdrr = () => {
  return HttpUtils.get("/web/ipUtils/getIpAddr")
} 


// 根据经纬度获取城市
const getCityByLngLat = (lng: number, lat: number) => {
  return HttpUtils.get(`/web/geo/query?longitude=${lng}&latitude=${lat}`)}

// 根据ip获取城市位置
const getCityByIp = (ip: string) => { 
  return HttpUtils.get(`/web/geo/queryByIp?ip=${ip}`)  
} 

// 根据accessPath查询访问统计数据
const queryTotalPvByAccessPath = (accessPath: string) => {
  return HttpUtils.get(`/web/access-statistics/count-pv-by-path?accessPath=${accessPath}`)
}

const CommonService = {
  recordAccess,
  getRealIpAdrr,
  getCityByLngLat,
  getCityByIp,
  queryTotalPvByAccessPath
}

export default CommonService;